import React from 'react';
// material-ui
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import logo from '../../../../assets/images/ply_decor.jpeg';


// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// Update the styled components
const LogoWrapper = styled(Box)(({ theme }) => ({
  display: 'none', // Hide by default on web
  [theme.breakpoints.down('sm')]: {
    // Show only on mobile
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px',
  }
}));

const Logo = styled('img')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '120px',
    height: '120px',
  }
}));

const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.7rem',
    textAlign: 'center',
    width: '100%',
  }
}));

// ==============================|| MENULIST ||============================== //

const MenuList = () => {
  const token = localStorage.getItem("token");
  if (token && localStorage.getItem('PageReloaded') === 'false') {
    localStorage.setItem('PageReloaded', true);
    // window.location.href = '/dashboard/default';
  }

  return (
    <>
      <LogoWrapper>
        <Logo 
          src={logo}
        />
        <Title variant="h6">
          All Plywood Products... One Trusted Name !!
        </Title>
      </LogoWrapper>
      
      {menuItem.items.map((item) => {
        switch (item.type) {
          case 'group':
            return <NavGroup key={item.id} item={item} />;
          default:
            return (
              <Typography key={item.id} variant="h6" color="error" align="center">
                Menu Items Error
              </Typography>
            );
        }
      })}
    </>
  );
};

export default MenuList;
